<script>
import Spinner from '@/components/atoms/Spinner'
export default {
    name: 'NoResult',
    components: { Spinner },
    props: {
        loading: Boolean,
    },
}
</script>

<template lang="pug">
spinner.d-block.mx-auto(v-if="loading" :size="30")
p.text-center.mt-4(v-else)
    slot

</template>
